export const environment = {
	serverUrl: 'https://staging-api.deck-of-dice-games.net'
};